import * as Sentry from '@sentry/nextjs';

export function SentryMinimal(): typeof Sentry {
  return Sentry;
}
